import { Grid2, Box, Typography, Button } from '@mui/material';
import React from 'react';
import './AboutUs.css';

const AboutUsDetails: React.FC = () => {
    return (
        <Box className="main-AboutUs-2">
            <Grid2
                container
                spacing={{xs: 1, md: 2}}
                justifyContent="center"
                alignItems="center"
                className="about-us-Grid22"
                columns={{xs: 12}}
                size={{xs:12}}
            >
                <Grid2 size={{ sm: 10, md: 9 }}>
                    <Typography className="h1" align="center">
                        About Us
                    </Typography>
                </Grid2>

                <Grid2 size={{ sm: 10, md: 9 }} className={'txt-parent'}>
                    <Typography>
                        At <b>8Rabbits</b>, we are revolutionizing the casino table game experience through innovation and creativity. As the exclusive game development studio partnered with the Ignite platform, we breathe new life into timeless classics like poker and blackjack.
                    </Typography>
                    <Typography>
                        Our mission is simple yet bold: we don’t just replicate the game; we elevate it. We create familiar and refreshingly innovative games by blending unique features with our distinctive design philosophy.
                    </Typography>
                    <Typography>
                        In a competitive market where novelty and player engagement is key, 8Rabbits stands out by delivering unforgettable gaming experiences designed to captivate players and keep them coming back for more.
                    </Typography>
                    <Typography className={'txt-gap'}>
                        All of our games are fully localized and available in 27 languages, ensuring a global reach and an engaging player experience across diverse markets. Built on the cutting-edge Ignite platform, our games offer quick and seamless implementation, delivering innovation with efficiency.
                    </Typography>
                    <Typography className={'txt-gap'}>
                        <p>
                        We are fueled by three core principles that define our success:
                        </p>
                        <p>
                            <b>Focus:</b> We prioritize crafting innovative table game variations that captivate players across all generations—from Boomers to Millennials and Gen Z.
                        </p>
                        <p>
                            <b>Approach:</b> We transform familiar favorites into extraordinary experiences by adding unique features to keep players returning for more.
                        </p>
                        <p>
                            <b>Capitalize:</b> We tap into player behaviors and preferences to drive repeated engagement, ensuring our fresh, innovative games maximize excitement and profitability.
                        </p>
                    </Typography>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default AboutUsDetails;